<template>
  <div v-if="isOpen" class="fixed inset-0 z-50 overflow-y-auto" role="dialog" aria-modal="true">
    <!-- Overlay -->
    <div class="fixed inset-0 bg-gray-900 bg-opacity-75 transition-opacity" @click="closeModal"></div>

    <!-- Modal panel -->
    <div class="flex min-h-full items-center justify-center md:p-4">
      <div
        class="relative w-full md:max-w-xl transform overflow-hidden bg-white shadow-xl transition-all flex flex-col min-h-screen md:min-h-0 md:max-h-[90vh] md:rounded-lg"
      >
        <!-- Header - Fixed -->
        <div class="px-6 py-4 flex justify-between items-center flex-shrink-0">
          <h3 class="text-lg font-semibold text-gray-900">
            <slot name="title"></slot>
          </h3>
          <button @click="closeModal" class="text-gray-400 hover:text-gray-500">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
          </button>
        </div>

        <!-- Body - Scrollable -->
        <div class="px-6 py-4 overflow-y-auto flex-grow">
          <slot name="body"></slot>
        </div>

        <!-- Footer - Fixed -->
        <div class="px-6 py-4 flex-shrink-0">
          <slot name="footer">
            <SecondaryButton @click="closeModal" :size="'md'" :roundedFull="true">Close</SecondaryButton>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SecondaryButton from '@/components/Molecules/SecondaryButton'

export default {
  name: 'Modal',
  components: {
    SecondaryButton
  },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  watch: {
    isOpen(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = ''
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit('close')
    }
  },
  beforeUnmount() {
    document.body.style.overflow = ''
  }
}
</script>
